import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, watch } from 'vue'
import { usePageStore } from '@/store/page'


export default /*#__PURE__*/_defineComponent({
  __name: 'ToastAlert',
  setup(__props) {

const openToast = ref(false)
const timeout = ref()
const pageStore = usePageStore()
watch(() => openToast.value, (value) => {
  if(value) {
    timeout.value = setTimeout(() => {
      openToast.value = false
      pageStore.showToast = false
    }, 3000)
  } else {
    clearTimeout(timeout.value)
  }
})

watch(() => pageStore.showToast, (value) => {
  if(value) {
    openToast.value = true
  }
})

return (_ctx: any,_cache: any) => {
  const _component_BToast = _resolveComponent("BToast")!

  return (_openBlock(), _createBlock(_component_BToast, {
    modelValue: openToast.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((openToast).value = $event)),
    autoHide: "",
    noHoverPause: "",
    variant: "light",
    toastClass: "position-absolute top-0 end-0 toast-index",
    isStatus: "",
    noCloseButton: "",
    bodyClass: _unref(pageStore).toastInfo.bgClass,
    title: _ctx.$t('common.status'),
    body: _unref(pageStore).toastInfo.body
  }, null, 8, ["modelValue", "bodyClass", "title", "body"]))
}
}

})